import { render, staticRenderFns } from "./packingIndex.vue?vue&type=template&id=517637cc&"
import script from "./packingIndex.vue?vue&type=script&lang=js&"
export * from "./packingIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports